/* eslint-disable react/jsx-props-no-spreading */
import styled from "styled-components";
import { AutoComplete } from "antd/";
import color from "../_style/color";

export default styled(AutoComplete).attrs((props) => ({
  filterOption: false,
  dropdownStyle: { border: `1px solid ${color.gainsboro}`, boxShadow: "unset" },
  margin: props.margin,
  width: props.width || "100%",
  padding: props.padding,
  mt: props.mt,
  mb: props.mb,
  ml: props.ml,
  mr: props.mr,
  pt: props.pt,
  pb: props.pb,
  pl: props.pl,
  pr: props.pr,
}))`
  width: ${({ width }) => width};
  cursor: auto;

  margin-top: ${({ mt }) => mt};
  margin-bottom: ${({ mb }) => mb};
  margin-left: ${({ ml }) => ml};
  margin-right: ${({ mr }) => mr};
  margin: ${({ margin }) => margin};
  padding: ${({ padding }) => padding};
  padding-top: ${({ pt }) => pt};
  padding-bottom: ${({ pb }) => pb};
  padding-left: ${({ pl }) => pl};
  padding-right: ${({ pr }) => pr};
`;
